export default {
    title_1: 'Lee las p*nches instrucciones',
    title_2: 'para',
    subtitle:
        'Se desecharon 500,000 boletas enviadas por correo durante las elecciones primarias. Asegúrate de que se cuente la tuya.',
    election_banner_title:
        'El día de las elecciones es el 3 de noviembre de 2026.',
    qualification_title: 'puedes votar por correo si',
    qualification_or_title: 'O',
    military_title: 'Militares y votantes en el extranjero',
    deadlines_title: 'Fechas límite',
    instructions_title: 'Instrucciones',
    share_title: 'Compartir',
    share_description: '¡Diles a tus amigos que no la c*guen!',
    resources_title: 'Recursos',
    video_title: 'Recordatorio',
    trust_title: 'Ten confianza, pero verifica',
};
